import { createAction } from '@reduxjs/toolkit';

export const sliderUpdateId = createAction('slider/updateId');
export const sliderUpdateUID = createAction('slider/updateUID');
export const sliderUpdateSID = createAction('slider/updateSID');
export const sliderUpdateIsAdded = createAction('slider/updateIsAdded');
export const sliderUpdateIsActive = createAction('slider/updateIsActive');

export const sliderStore = createAction('slider/store');
export const sliderClear = createAction('slider/clear');

export const sliderUpdateRequesting = createAction('slider/updateRequesting');
export const sliderUpdateRequest = createAction('slider/updateRequest');
export const sliderUpdateError = createAction('slider/updateError');
export const sliderUpdateStore = createAction('slider/updateStore');

export const sliderUpdateItems = createAction('slider/updateItems');
export const sliderUpdateLayout = createAction('slider/updateLayout');
export const sliderUpdateWidth = createAction('slider/updateWidth');
export const sliderUpdateView = createAction('slider/updateView');
export const sliderUpdateTitleSize = createAction('slider/updateTitleSize');

export const sliderUpdateHeadingTitle = createAction('slider/updateHeadingTitle');
export const sliderUpdateHeadingDescription = createAction('slider/updateHeadingDescription');
export const sliderUpdateHeadingTextAlign = createAction('slider/updateHeadingTextAlign');
export const sliderUpdateHeadingImage = createAction('slider/updateHeadingImage');
export const sliderUpdateHeadingDivider = createAction('slider/updateHeadingDivider');

export const sliderUpdateSectionIsBackground = createAction('slider/updateSectionIsBackground');
export const sliderUpdateSectionTextColor = createAction('slider/updateSectionTextColor');
export const sliderUpdateSectionBackgroundColor = createAction('slider/updateSectionBackgroundColor');
export const sliderUpdateSectionOpacity = createAction('slider/updateSectionOpacity');
export const sliderUpdateSectionIsFullWidth = createAction('slider/updateSectionIsFullWidth');
export const sliderUpdateSectionShadow = createAction('slider/updateSectionShadow');
export const sliderUpdateSectionShadowColor = createAction('slider/updateSectionShadowColor');
export const sliderUpdateSectionPadding = createAction('slider/updateSectionPadding');
export const sliderUpdateSectionMargin = createAction('slider/updateSectionMargin');
export const sliderUpdateSectionBackgroundType = createAction('slider/updateSectionBackgroundType');
export const sliderUpdateSectionBackgroundImage = createAction('slider/updateSectionBackgroundImage');
export const sliderUpdateSectionGradientColor1 = createAction('slider/updateSectionGradientColor1');
export const sliderUpdateSectionGradientColor2 = createAction('slider/updateSectionGradientColor2');
export const sliderUpdateSectionGradientDirection = createAction('slider/updateSectionGradientDirection');
export const sliderUpdateSectionGradientOffset = createAction('slider/updateSectionGradientOffset');
export const sliderUpdateSectionBorder = createAction('slider/updateSectionBorder');
export const sliderUpdateSectionBorderColor = createAction('slider/updateSectionBorderColor');
export const sliderUpdateSectionShadowBorderColor = createAction('slider/updateSectionShadowBorderColor');
export const sliderUpdateSectionShape = createAction('slider/updateSectionShape');
